<template>
  <div class="page-container">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <el-loading text="加载中..." background="rgba(255,255,255,0.8)" />
    </div>
    
    <div v-show="!loading" class="page-content-wrapper">
      <!-- <div class="page-header">
        <h1 class="page-title">参军规划</h1>
      </div> -->
      
      <!-- 职业发展信息卡片 -->
      <div v-if="careerData" class="career-info-card">
        <div class="career-header">
          <span class="career-icon">📊</span>
          <h3 class="career-title">职业发展指南</h3>
        </div>
        <div class="career-content" v-html="processedContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCareerInfo } from "@/api/careerApi";
import { baseURL } from "@/api/axiosConfig";
export default {
  name: "ServicePlanning",
  data() {
    return {
      careerData: null,
      loading: true,
      processedContent: "",
    };
  },
  mounted() {
    this.fetchCareerInfo();
  },
  methods: {
    async fetchCareerInfo() {
      try {
        const response = await getCareerInfo();
        if (response.data.code === 200) {
          this.careerData = response.data.data;
          this.processContent();
        }
      } catch (error) {
        console.error("获取职业发展信息失败:", error);
      } finally {
        this.loading = false;
      }
    },
    processContent() {
      if (this.careerData && this.careerData.pdfurl) {
        // 将图片路径中的 /dev-api 替换为基础URL
        this.processedContent = this.careerData.pdfurl.replace(
          /src=\"\/dev-api(\/profile\/upload\/[^"]+)\"/g,
          `src="${baseURL}$1"`
        );
      }
    }
  }
};
</script>

<style scoped>
.page-container {
  margin-top: 60px;
  padding: 0px 0px 20px;
  background: linear-gradient(135deg, #fff3e0 0%, #f0f4f8 100%);
  box-sizing: border-box;
}

.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
}

.career-info-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-left: 4px solid #ff9800;
}

.career-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.career-icon {
  font-size: 32px;
}

.career-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.career-content {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

.career-content * {
  font-size: inherit !important;
  line-height: inherit !important;
  color: inherit !important;
}

.career-content h1 {
  font-size: 20px !important;
  color: #333 !important;
  font-weight: bold !important;
  margin-bottom: 16px !important;
}

.career-content p {
  margin-bottom: 12px !important;
  text-indent: 2em;
}

.page-title {
  font-size: 32px;
  color: #e65100;
  margin: 0 0 8px 0;
  font-weight: bold;
}
</style>
